import { Injectable } from "@angular/core";

import { PaginationOptionsModel } from "../../../shared-library/form-controls/pagination/pagination-options.model";

@Injectable({
    providedIn: "root"
})
export class PaginationOptionsFactoryService {
    public constructor() {
    }

    public createDefaultPaginationOptions(): PaginationOptionsModel {
        const model = new PaginationOptionsModel();

        model.buttonsCount = 5;

        model.showGoToFirst = false;
        model.showGoToLast = false;

        model.labelPrevious = "";
        model.labelNext = "";

        return model;
    }
}
